import {createFileRoute} from "@tanstack/react-router";

export const Route = createFileRoute("/(auth)/_layout/manage/")({
	component: ManageScreen
});

function ManageScreen() {
	return <div></div>;
}
